import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { ModalService } from '../../../../services/modal/modal.service';
import { ApplicationService } from '../../../../services/application/application.service';
import { BaseModalComponent } from '../../base-modal.component';
import { UnsupportedCase, UnsupportedCaseText, UnsupportedCaseHeader } from '../../../../classes/UnsupportedUseCases';
import { WindowService } from '../../../../../../common/angular-shared/services/window/window.service';
import { Product } from '../../../../../../common/js/static/Product';

@Component({
  moduleId: module.id,
  selector: 'unsupported-cases',
  templateUrl: './unsupported-cases.component.html',
})
export class UnsupportedCasesComponent extends BaseModalComponent implements OnInit {
  modalText: Array<string>;
  isAdvisor: boolean;
  modalHeader: string = 'Not Yet Available';

  constructor(
    private amorphicService: AmorphicService,
    private appService: ApplicationService,
    private router: Router,
    modalService: ModalService,
    private windowService: WindowService
  ) {
    super(modalService);
  }

  ngOnInit() {
    const unsupportedCase = UnsupportedCase[this.data.unsupportedCase];

    this.modalHeader = UnsupportedCaseHeader[unsupportedCase]
      ? UnsupportedCaseHeader[unsupportedCase]
      : this.modalHeader;
    const channel = this.appService.appState.controller.customer.application.primaryPolicy.getChannelCode();
    const isCAS = channel === Product.channels.CAS.code ? true : false;
    if (
      (!this.windowService.nativeWindow.controller.enableNewReplacementFeature &&
        unsupportedCase === 'isReplacementOther' &&
        isCAS) ||
      !isCAS
    ) {
      this.modalHeader = this.modalHeader;
    } else if (unsupportedCase === 'lifeBridge' && channel !== Product.channels.LifeBridge.code) {
      this.modalHeader = this.modalHeader;
    }

    if (this.data.unsupportedCaseData) {
      // Assigning non generic text created for modal when unsupportedCaseData exist
      this.modalText = this.data.unsupportedCaseData.split('|');
    } else {
      this.modalText = UnsupportedCaseText[unsupportedCase].split('|');
    }

    this.isAdvisor = this.appService.appState.isAdvisor;
  }

  cancel() {}
  confirm() {}

  goBack() {
    this.modalService.deactivate();
  }

  exit() {
    if (this.isAdvisor) {
      this.router.navigate(['home']);
    }
  }
}
